import { render, staticRenderFns } from "./CommentStepTree.vue?vue&type=template&id=2fde0069"
import script from "./CommentStepTree.vue?vue&type=script&lang=js"
export * from "./CommentStepTree.vue?vue&type=script&lang=js"
import style0 from "./CommentStepTree.vue?vue&type=style&index=0&id=2fde0069&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports